import Swiper from 'swiper/bundle';

if ($('.slider-type-1-image').length && $('.slider-type-1-text').length) {
	var sliderType1Image = [];
	var sliderType1Text = [];

	$('.slider-type-1-image').each(function(index) {
		sliderType1Image[index] = new Swiper($(this)[0], {
			slidesPerView: 1,
			centeredSlides: false,
			autoHeight: true,
			spaceBetween: 16,
			speed: 600,
			autoplay: false,
			loop: false,
			watchSlidesProgress: true,
			touchEventsTarget: 'wrapper',
			allowTouchMove: true,
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
				slideChangeTransitionStart: function (swiper) {

				},
				slideChange: function () {
					sliderType1Text[index].slideTo(sliderType1Image[index].realIndex);
				},
			},
		});
	})

	$('.slider-type-1-text').each(function(index) {
		sliderType1Text[index] = new Swiper($(this)[0], {
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 16,
			autoHeight: true,
			speed: 600,
			autoplay: false,
			loop: false,
			touchEventsTarget: 'wrapper',
			watchSlidesProgress: true,
			navigation: {
				nextEl: $(this).closest('section').find('.swiper-button-next')[0],
				prevEl: $(this).closest('section').find('.swiper-button-prev')[0],
			},
			thumbs: {
			  	swiper: sliderType1Image[index],
			},
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
			},
		});
	})
}


if ($('.cta-type-1').length) {
	$('.cta-type-1').each(function() {
		window.ctaType1 = new Swiper($(this)[0], {
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 16,
			speed: 1000,
			autoplay: {
				delay: 2000,
				disableOnInteraction: false
			},
			loop: true,
			scrollbar: false,
			navigation: false,
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
			},
		});
	})
}


if ($('.hero-type-1').length) {
	var heroType1 = new Swiper(".hero-type-1", {
		slidesPerView: 1,
		centeredSlides: false,
		// spaceBetween: 16,
		// speed: 1000,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 4000,
			disableOnInteraction: false
		},
		loop: true,
		scrollbar: false,
		navigation: false,
	});
}


if ($('.hero-type-3').length) {
    var heroType3 = new Swiper('.hero-type-3', {
        slidesPerView: 1,
        centeredSlides: false,
        speed: 900,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        loop: true,
        allowTouchMove: false,
        navigation: false,
        pagination: false,
    });
}



if ($('.image-type-3').length) {
	$('.image-type-3').each(function() {
		window.imageType3 = new Swiper($(this)[0], {
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 16,
			speed: 600,
			autoHeight: true,
			autoplay: false,
			loop: false,
			scrollbar: {
				el: $(this).closest('section').find('.swiper-scrollbar')[0],
				draggable: true,
			},
			navigation: false,
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
			on: {
				init: function () {
					// console.log('swiper initialized');
				},
			},
		});
	})
}

if ($('.slider-gallery-big').length) {
	var galleryThumb = new Swiper(".slider-gallery-thumb", {
		spaceBetween: 10,
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			1024: {
				slidesPerView: 5,
			},
		},
	});
	var galleryBig = new Swiper(".slider-gallery-big", {
		spaceBetween: 10,
		navigation: {
			nextEl: $('[data-gallery]').find('.swiper-button-next')[0],
			prevEl: $('[data-gallery]').find('.swiper-button-prev')[0],
		},
		thumbs: {
			swiper: galleryThumb,
		},
		hashNavigation: {
			watchState: true,
		},
		watchSlidesProgress: true,
		on: {
			init: function () {
				// console.log('swiper initialized');
			},
			slideChangeTransitionStart: function (swiper) {
				console.log()
				$('[data-gallery] .slider-progress .current').text(swiper.realIndex + 1);
			},
		},
	});
}


if ($('.slider-type-2-cards').length) {
	$('.slider-type-2-cards').each(function(index) {
		var sliderType2 = new Swiper($(this)[0], {
			slidesPerView: 1,
			slidesPerGroup: 1,
			centeredSlides: false,
			spaceBetween: 16,
			speed: 600,
			/*autoplay: {
				delay: 2500,
				pauseOnMouseEnter: true,
			},*/
			loop: true,
			scrollbar: false,
			navigation: {
				nextEl: $(this).closest('section').find('.swiper-button-next')[0],
				prevEl: $(this).closest('section').find('.swiper-button-prev')[0],
			},
			breakpoints: {
				480: {
					slidesPerView: 1.2,
					slidesPerGroup: 1,
				},
				640: {
					slidesPerView: 1.5,
					slidesPerGroup: 1,
				},
				768: {
					slidesPerView: 2,
					slidesPerGroup: 2,
				},
				1024: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: 48,
				},
				1280: {
					slidesPerView: 3,
					slidesPerGroup: 1,
					spaceBetween: 48,
				},
			},
			on: {
				init: function () {
					// console.log('sliderType2 initialized');
				},
			},
		});
	});
}

var announcementSlider = $('.swiper-announcements');
if (announcementSlider.length) {
	announcementSlider.each(function() {
		var nextEl = $(this).closest('aside').find('.swiper-button-next');
		var prevEl = $(this).closest('aside').find('.swiper-button-prev');
		window.slider = new Swiper($(this)[0], {
			slidesPerView: 1,
			spaceBetween: 20,
			autoHeight: true,
			speed: 600,
			autoplay: {
				delay: 4000,
				pauseOnMouseEnter: true,
			},
			pagination: false,
			centeredSlides: false,
			navigation: {
				nextEl: nextEl[0],
				prevEl: prevEl[0],
			},
			freeMode: false,
			loop: true,
			touchEventsTarget: 'wrapper',
			// on: {
			// 	init: function () {
			// 		setMaxWidthForSwiper('.swiper-announcements');
			// 		this.update();
			// 	},
			// 	resize: function () {
			// 		setMaxWidthForSwiper('.swiper-announcements');
			// 	},
			// },
		});
	});
}